/* global alert */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { orderObjectSelector } from '@arreeba/ristoranti-frontend-lib';

import { COMMON_LOCALIZED } from '../../lib/localized';
import { connect } from '../../util';
import { orderLocationAddressSelector } from '../../selectors/orderSelectors';
import { urlSelector } from '../../selectors/urlSelectors';
import { Cart } from '../../components/cart';
import OrderRecap from '../../components/order-recap';

const OrderStatus = (props) => {
  const classes = classnames(
    'orderEndStatus',
    `orderEndStatus--${props.status}`,
  );
  return (
    <div className={classes}>
      <i className={props.icon} />
      <h4>{props.title}</h4>
      <div className="orderEndStatus__content">
        {props.children}
      </div>
    </div>
  );
};
OrderStatus.propTypes = {
  title: PropTypes.string,
  status: PropTypes.oneOf(['pending', 'confirmed', 'denied']),
  icon: PropTypes.string,
  children: PropTypes.node,
};

const OrderEndPending = (props) => {
  const deliveryOrTakeaway = props.orderType === 'delivery' ? 'consegna' : 'ritiro';
  const total = props.total;
  const subtotal = props.subtotal;
  const extraCosts = props.extraCosts;
  const items = props.cart;
  return (
    <OrderStatus
      title="il tuo ordine è stato inviato al ristorante"
      status="pending"
      icon="bi_com-paperplane"
    >
      <div>
        <p>
          A breve ti verrà confermato l'orario di {deliveryOrTakeaway},
          segui qui lo stato del tuo ordine
        </p>
        <Cart
          items={items}
          subtotal={subtotal}
          total={total}
          extraCosts={extraCosts}
        />
        <OrderRecap
          date={props.orderDate}
          location={props.orderAddress}
        />
      </div>
    </OrderStatus>
  );
};

const OrderEndConfirmed = (props) => {
  const total = props.total;
  const subtotal = props.subtotal;
  const extraCosts = props.extraCosts;
  const items = props.cart;
  return (
    <OrderStatus
      title="il tuo ordine è stato confermato"
      status="confirmed"
      icon="bi_interface-circle-tick"
    >
      <div>
        <Cart
          items={items}
          subtotal={subtotal}
          total={total}
          extraCosts={extraCosts}
        />
        <OrderRecap
          date={props.confirmationDate}
          location={props.orderAddress}
        />
      </div>
    </OrderStatus>
  );
};

const OrderEndDenied = (props) => {
  return (
    <OrderStatus
      title="il tuo ordine è stato annullato"
      status="denied"
      icon="bi_misc-mood-sad"
    >
      <p>Il ristorante non può prendere in carico il tuo ordine in questo momento.</p>
    </OrderStatus>
  );
};

const statusMap = {
  PENDING: OrderEndPending,
  DECLINED: OrderEndDenied,
  CONFIRMED: OrderEndConfirmed,
};

class OrderEnd extends React.Component {
  constructor(props) {
    super(props);
    this.updateOrderStatus = this.updateOrderStatus.bind(this);
  }

  componentDidMount() {
    this.updateOrderStatus();
  }

  updateOrderStatus() {
    this.props.services.order.updateCurrentOrder(
      this.props.app.id,
      this.props.order.currentOrder.id,
      this.props.actions.order,
    );
    setTimeout(() => {
      if (this.props.order.currentOrder.status === 'PENDING') {
        this.updateOrderStatus();
      }
    }, 10000);
  }

  render() {
    const orderObject = this.props.orderObject;
    const currentOrder = this.props.order.currentOrder;
    const extraCosts = orderObject.extraCosts;
    const orderAddress = this.props.orderLocation.address;
    const orderType = this.props.url.orderType;
    const orderDate = this.props.url.orderDate;
    const confirmationDate = currentOrder.confirmation ?
      currentOrder.confirmation.date : '';
    const data = {
      orderType,
      orderDate,
      orderAddress,
      confirmationDate,
      cart: orderObject.cart,
      extraCosts,
      subtotal: orderObject.subtotal,
      total: orderObject.total,
    };
    const status = currentOrder.status;
    const StatusView = statusMap[status];

    if (!StatusView) {
      this.props.actions.ux.setMessage({
        title: 'Errore',
        text: 'Si è verificato un errore imprevisto',
        type: 'error',
      });
      return <div>error</div>;
    }

    return (
      <main>
        <StatusView {...data} />
      </main>
    );
  }
}

const mapStateToProps = (state, props) => ({
  app: state.app,
  order: state.order,
  url: urlSelector(state, props),
  orderLocation: orderLocationAddressSelector(state, props),
  orderObject: orderObjectSelector(COMMON_LOCALIZED)(state, props),
});
export default connect(OrderEnd, { mapStateToProps });



// WEBPACK FOOTER //
// ./src/containers/order/order-end.js